import { ITriggerRuleSettingsModel } from '../../interfaces/ITriggerRule';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useUpdateTriggerMutation = (onError: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (trigger: ITriggerRuleSettingsModel) => {
            const response = await zoneApiClient.updateTrigger(trigger);

            if (response && !response?.httpResponse.ok) {
                if (response.httpResponse.status === 400
                ) {
                    throw new Error(`Failed to update Trigger : ${response.errorMessage}`);
                }
                else if (response.httpResponse.status === 403
                ) {
                    throw new Error(`Forbidden to update trigger`);
                }
                throw new Error('Failed to update Trigger');
            }
        return response!.payload!;
        },
        onError(error) {
            if (error instanceof Error) {
                onError(error.message);
            }
        },
    });
}
